export default __webpack_public_path__ + "static/media/modal04.fd1be156.mp4";